import { render, staticRenderFns } from "./ListEventosUsuario.vue?vue&type=template&id=36124865&"
import script from "./ListEventosUsuario.vue?vue&type=script&lang=js&"
export * from "./ListEventosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ListEventosUsuario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports